import { QuantidadeAlimentacaoDiariaEnum } from 'graphql/types.generated'
import { quantidadeAlimentacaoDiariaRecord } from 'types/enums'

import { RadioGroupField, RadioGroupFieldProps } from './RadioGroupField'
import { recordToSortedRadioOptions } from './utils-field'

type QuantidadeAlimentacaoDiariaRadioGroupFieldProps = Readonly<
  Omit<RadioGroupFieldProps<QuantidadeAlimentacaoDiariaEnum>, 'label' | 'options'>
>

export function QuantidadeAlimentacaoDiariaRadioGroupField(props: QuantidadeAlimentacaoDiariaRadioGroupFieldProps) {
  return <RadioGroupField options={options} {...props} clearable />
}

const options = recordToSortedRadioOptions(quantidadeAlimentacaoDiariaRecord)
